import { render, staticRenderFns } from "./ProductInventoryStatistic.vue?vue&type=template&id=64e887cd&scoped=true"
import script from "./ProductInventoryStatistic.vue?vue&type=script&lang=ts"
export * from "./ProductInventoryStatistic.vue?vue&type=script&lang=ts"
import style0 from "./ProductInventoryStatistic.vue?vue&type=style&index=0&id=64e887cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e887cd",
  null
  
)

export default component.exports